import './home.css';

export const Home = () => {
  return (
    <div className='home-container'>
                {/* <div>
            <img src={`${s3}/expressive_expansionisms_detail_b.jpg`} className='home-image img-fluid' alt='expressive_expansionisms'/> */}
          {/* </div> */}
               {/* <div> 
            <img src={`${s3}/expressive_expansionisms.jpg`} className='small-home-image img-fluid' alt='expressive_expansionisms'/>
          </div> */}
        {/* <section className='home-image-container'> */}
          {/* <div>
            <img src={`${s3}/expressive_expansionisms_detail_b.jpg`} className='home-image img-fluid' alt='expressive_expansionisms'/>
          </div> */}
          {/* <div>
            <img src={`${s3}/expressive_expansionisms_detail_b.jpg`} className='home-image img-fluid' alt='expressive_expansionisms'/>
          </div>
          <div>
            <img src={`${s3}/expressive_expansionisms_detail_b.jpg`} className='home-image img-fluid' alt='expressive_expansionisms'/>
          </div>  */}
          {/* <div> 
            <img src={`${s3}/expressive_expansionisms.jpg`} className='small-home-image img-fluid' alt='expressive_expansionisms'/>
          </div> */}
        {/* </section> */}
    </div>
  );
}

